import React from 'react'
import { useMsal } from "@azure/msal-react"
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { selectUser, setSpoofedUser } from '../../redux/userSlice'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserSecret } from "@fortawesome/free-solid-svg-icons";
import { clearMsalLoginHint } from '../../msalConfig'

export default function NavProfile({ onLink }) {
  const { instance } = useMsal()
  const dispatch = useDispatch()

  const logout = async () => {
    localStorage.removeItem('persist:root')
    clearMsalLoginHint()
    // Will redirect to MSAL to end the session then redirect back to the configured `postLogoutRedirectUri`
    await instance.logoutRedirect() //Signs user out of MSAL
  }

  const user = useSelector(selectUser)
  const activeUser = user.spoofed_user.id ? user.spoofed_user : user.data

  if (user.status !== 'succeeded') return null

  return (
    <div className="dropdown-menu" role="menu">
      <div className="dropdown-content">
        <div className="dropdown-item">
          <span className="title is-6 has-text-primary is-text-centered">
            {`${activeUser.first_name} ${activeUser.last_name}`}
          </span>
        </div>
        <hr className="dropdown-divider" />
        {user.spoofed_user.id ? (
          <>
            <Link
              to="/home"
              className="dropdown-item py-0"
              onClick={() => {
                dispatch(setSpoofedUser({ spoofed_user: {} }))
                onLink()
              }}
            >
              <FontAwesomeIcon icon={faUserSecret} className={'is-size-6 pr-1'} />
              Return to {user.data.first_name + ' ' + user.data.last_name}
            </Link>
            <hr className="dropdown-divider" />
          </>
        ) : ''}
        <Link to="/" onClick={logout} className="dropdown-item py-0">
          Logout
        </Link>
      </div>
    </div>
  )
}
